import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import { api } from '../api';

export default function TestCaseList() {
  const { projectId, suiteId } = useParams();
  const navigate = useNavigate();
  const { refreshKey } = useContext(AppContext);
  const [testCases, setTestCases] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [suiteData, setSuiteData] = useState(null);

  useEffect(() => {
    if (!suiteId) { setTestCases([]); setSuiteData(null); return; }
    setLoading(true);
    api.getSuite(Number(suiteId)).then(setSuiteData);
    if (searchQuery.trim()) {
      api.searchTestCases(searchQuery).then((r) => { console.log('Search results:', r); setTestCases(r); setLoading(false); });
    } else {
      api.getTestCases(Number(suiteId)).then((r) => { console.log(`Fetched TCs for suite ${suiteId}:`, r); setTestCases(r); setLoading(false); });
    }
  }, [suiteId, refreshKey, searchQuery]);

  if (!suiteId) return <div className="tc-empty">Select a suite</div>;

  return (
    <div>
      {suiteData && (
        <div className="suite-header-bar">
          <h2>{suiteData.name}</h2>
          <button
            className="btn-icon"
            onClick={() => navigate(`/projects/${projectId}/suites/${suiteId}/edit`)}
            title="Edit suite"
          >
            ✎
          </button>
        </div>
      )}
      <div className="tc-list-header">
        <h3>{searchQuery ? 'Search Results' : 'Test Cases'}</h3>
        {!searchQuery && (
          <button
            className="btn-primary"
            style={{ padding: '4px 12px', fontSize: 12 }}
            onClick={() => navigate(`/projects/${projectId}/suites/${suiteId}/cases/new`)}
          >
            + New
          </button>
        )}
      </div>
      <input
        className="search-input"
        placeholder="Search test cases..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {loading && <div className="tc-empty">Loading...</div>}
      {!loading && testCases.length === 0 && (
        <div className="tc-empty">
          {searchQuery ? 'No results found' : 'No test cases yet'}
        </div>
      )}
      {!loading && testCases.map((tc) => (
        <div
          key={tc.id}
          className="tc-item"
          onClick={() => navigate(`/projects/${projectId}/suites/${suiteId}/cases/${tc.id}`)}
        >
          <div className="tc-item-title">
            {tc.case_id && <span className="tc-case-id">{tc.case_id}</span>}
            {tc.title}
          </div>
          <div className="tc-item-meta">
            {tc.priority} · {tc.steps?.length || 0} steps
            {tc.tags?.length > 0 && ` · ${tc.tags.map((t) => t.name).join(', ')}`}
          </div>
        </div>
      ))}
    </div>
  );
}
